__turbopack_context__.v({
  "component": "style-module-scss-module__z-jSka__component",
  "exp": "style-module-scss-module__z-jSka__exp",
  "menu-items": "style-module-scss-module__z-jSka__menu-items",
  "mobile": "style-module-scss-module__z-jSka__mobile",
});
